/** Nội dung wiki / blog chính thức (WordPress). Nguồn URL trong sitemap post của tsorigin.com */

export const WIKI_ORIGIN = "https://tsorigin.com" as const;

export function wikiUrl(path: string): string {
  const p = path.startsWith("/") ? path.slice(1) : path;
  const withSlash = p.endsWith("/") ? p : `${p}/`;
  return `${WIKI_ORIGIN}/${withSlash}`;
}

export type WikiCard = {
  path: string;
  title: string;
  description: string;
  tag: string;
  /** ảnh đại diện nếu có trong sitemap (tuỳ chọn) */
  imageSrc?: string;
};

/** Bài nổi bật trên trang chủ — lấy từ post-sitemap (ưu tiên tin mới & hướng dẫn cốt lõi) */
export const wikiFeatured: WikiCard[] = [
  {
    path: "/khai-mo-server-ts-origin-pc-s1-tao-thao/",
    title: "Khai mở server TS Origin PC S1 — Tào Tháo",
    description: "Thông tin mở máy chủ, giai đoạn khai phá và khởi đầu hành trình.",
    tag: "Tin server",
    imageSrc: "https://tsorigin.com/wp-content/uploads/2026/04/ChatGPT-Image-15_34_13-5-thg-2-2026.png",
  },
  {
    path: "/thong-tin-may-chu-ts-online-origin/",
    title: "Thông tin máy chủ TS Online Origin",
    description: "Tổng quan máy chủ, phiên bản và môi trường chơi TS Origin.",
    tag: "Máy chủ",
  },
  {
    path: "/gioi-thieu-ts-online-ts-origin-hon-chien-tam-gioi/",
    title: "Giới thiệu TS Online — TS Origin Hỗn Chiến Tam Giới",
    description: "Nội dung thế giới, lối chơi và những điểm khác biệt của bản Origin.",
    tag: "Giới thiệu",
    imageSrc: "https://tsorigin.com/wp-content/uploads/2026/01/Gemini_Generated_Image_dr6pbldr6pbldr6p.png",
  },
  {
    path: "/tai-game-ts-online-moi-nhat-2026-huong-dan-chi-tiet-tu-a-z/",
    title: "Tải game TS Online mới nhất 2026 — hướng dẫn A–Z",
    description: "Tải bản chính thức, cài đặt và các bước vào game an toàn.",
    tag: "Cài đặt",
  },
  {
    path: "/tong-hop-nhung-quest-nen-lam/",
    title: "Tổng hợp quest nên làm",
    description: "Gợi ý nhiệm vụ ưu tiên cho tân thủ và người lên cấp.",
    tag: "Nhiệm vụ",
  },
  {
    path: "/thong-tin-data-cua-ts-online-origin-kim-an-items-skill-npc/",
    title: "Thông tin data TS Origin — Kim ấn, item, skill & NPC",
    description: "Tra cứu hệ thống vật phẩm, kỹ năng và NPC trong phiên bản Origin.",
    tag: "Tài liệu",
  },
  {
    path: "/trai-nghiem-huong-dan-chinh-phuc-cuu-thien/",
    title: "Trải nghiệm & hướng dẫn Chinh phục Cửu Thiên",
    description: "Lộ trình và mẹo thực chiến cho nội dung Cửu Thiên.",
    tag: "Hành trình",
    imageSrc: "https://tsorigin.com/wp-content/uploads/2026/02/chinh-phuc-cuu-thien-01.png",
  },
  {
    path: "/ts-online-ts-origin-hanh-trinh-chinh-phuc-cuu-thien/",
    title: "Hành trình Chinh phục Cửu Thiên",
    description: "Chuỗi nhiệm vụ và mục tiêu trong hành trình Cửu Thiên.",
    tag: "Hành trình",
  },
];

export type WikiTopicLink = { path: string; title: string };

export type WikiTopic = {
  id: string;
  title: string;
  description: string;
  links: WikiTopicLink[];
};

export const wikiTopics: WikiTopic[] = [
  {
    id: "server-news",
    title: "Tin tức & máy chủ",
    description: "Cập nhật máy chủ, mở S và câu hỏi thường gặp về PC.",
    links: [
      { path: "/thong-tin-may-chu-ts-online-origin/", title: "Thông tin máy chủ TS Online Origin" },
      { path: "/khai-mo-server-ts-origin-pc-s1-tao-thao/", title: "Khai mở server TS Origin PC S1 Tào Tháo" },
      { path: "/ts-online-con-ai-choi-khong-nam-2026/", title: "TS Online còn ai chơi không (2026)?" },
      { path: "/ts-online-pc-co-con-choi-duoc-khong/", title: "TS Online PC có còn chơi được không?" },
    ],
  },
  {
    id: "install",
    title: "Tải game & làm quen",
    description: "Cài đặt, khác biệt Mobile/PC và điều khoản người mới.",
    links: [
      { path: "/tai-game-ts-online-moi-nhat-2026-huong-dan-chi-tiet-tu-a-z/", title: "Tải game & hướng dẫn A–Z" },
      { path: "/ts-origin-mobile-va-ts-origin-pc-khac-nhau-the-nao/", title: "TS Origin Mobile và PC khác nhau thế nào?" },
      { path: "/ts-origin-mobile-la-gi-co-phai-game-chinh-thuc-tu-vtc/", title: "TS Origin Mobile là gì? Có phải bản chính thức?" },
      { path: "/quy-dinh-va-dieu-khoan-ho-tro-nguoi-choi-moi/", title: "Quy định & điều khoản hỗ trợ người chơi mới" },
    ],
  },
  {
    id: "quests",
    title: "Nhiệm vụ & kinh nghiệm",
    description: "Quest ưu tiên, chuỗi nhiệm vụ và phát triển nhân vật.",
    links: [
      { path: "/tong-hop-nhung-quest-nen-lam/", title: "Tổng hợp quest nên làm" },
      { path: "/tong-hop-cac-quest-duoc-phat-trien-moi/", title: "Quest được phát triển mới" },
      { path: "/tong-hop-cac-quest-lay-me/", title: "Tổng hợp quest lấy mê" },
      { path: "/kinh-nghiem-lam-chuoi-quest-me-di-di/", title: "Kinh nghiệm làm chuỗi quest Mê Đi Đi" },
      { path: "/diem-status-skill-sau-chuyen-sinh-va-tai-sinh/", title: "Điểm status & skill sau chuyển sinh / tái sinh" },
    ],
  },
  {
    id: "world",
    title: "Thế giới & hệ thống",
    description: "Data, NPC, lệnh phím tắt và tiện ích trong game.",
    links: [
      { path: "/thong-tin-data-cua-ts-online-origin-kim-an-items-skill-npc/", title: "Data Kim ấn, item, skill & NPC" },
      { path: "/he-thong-npc-trong-cac-rung-cua-cac-phung-ap-tai-ts-online-origin/", title: "Hệ thống NPC tại phủng ấp & rừng" },
      { path: "/mot-so-lenh-dac-biet-phim-tat-su-dung-tai-the-gioi-ts-origin/", title: "Lệnh đặc biệt & phím tắt trong TS Origin" },
      { path: "/thong-tin-tuong-dat-va-tuong-tinh-npc/", title: "Tướng đất & tướng tinh NPC" },
    ],
  },
  {
    id: "journeys",
    title: "Hành trình nội dung",
    description: "Các chuỗi hành trình, huy hiệu và nhiệm vụ lớn.",
    links: [
      { path: "/ts-online-ts-origin-hanh-trinh-chinh-phuc-cuu-thien/", title: "Hành trình Chinh phục Cửu Thiên" },
      { path: "/ts-online-tsorigin-hanh-trinh-loi-dai-50-vong-npc/", title: "Hành trình lôi đài 50 vòng NPC" },
      { path: "/ts-online-tsorigin-hanh-trinh-dai-chien-lu-bo/", title: "Hành trình Đại chiến Lữ Bố" },
      { path: "/ts-online-ts-origin-hanh-trinh-giai-cuu-khan-vang/", title: "Hành trình giải cứu khăn vàng" },
      { path: "/ts-online-ts-origin-huy-hieu-ts-online-origin/", title: "Huy hiệu TS Online Origin" },
    ],
  },
];
